import svgPaths from "./svg-21bbcckwk3";

function IntelligenicSymbol() {
    return (
        <svg
            style={{ display: "block", width: "100%", height: "100%", transform: "scale(1.2)" }}
            viewBox="0 0 73 90"
            preserveAspectRatio="xMidYMid meet" // keep aspect ratio + center
        >
            <g id="intelligenic-symbol">
                <path d={svgPaths.p1b887d80} fill="currentColor" />
                <path d={svgPaths.p10e2ed00} fill="currentColor" />
                <path d={svgPaths.pd7f3400} fill="currentColor" />
                <path d={svgPaths.p120b8300} fill="currentColor" />
            </g>
        </svg>
    );
}

export default function IntelligenicBrandIcon() {
    return (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
            <IntelligenicSymbol />
        </div>
    );
}
